import { apiTypeHelper } from '@/base/network'

export const GET_USER_PAYMENTS = apiTypeHelper('GET_USER_PAYMENTS')
export const ADD_USER_PACKAGE_PAYMENT = apiTypeHelper('ADD_USER_PACKAGE_PAYMENT')
export const GET_TOP_SALES_LIST = apiTypeHelper('GET_TOP_SALES_LIST')